import { render } from "./CreateUnit.vue?vue&type=template&id=2cc64777&scoped=true"
import script from "./CreateUnit.vue?vue&type=script&lang=js"
export * from "./CreateUnit.vue?vue&type=script&lang=js"

import "./CreateUnit.vue?vue&type=style&index=0&id=2cc64777&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc64777"]])

export default __exports__